export const levelsList = [
  { id: 1, title: "Beginner" },
  { id: 2, title: "Intermediate" },
  { id: 3, title: "Advanced" },
  { id: 4, title: "Pro" },
];
